<template>
  <div class="grid">
    <enemy-formation-card
      :v-if="normal"
      v-for="(enemy, index) in wave.enemylist"
      :key="index"
      :enemy="enemy.index"
      :level="convert(enemy.level)"
      @click="handleEnemy(enemy.index, convert(enemy.level))"
    />
    <enemy-formation-card
      :v-else-if="sanctum"
      v-for="(enemy, index) in sanctumWave"
      :key="index"
      :enemy="enemy.id"
      :level="convert(enemy.lv)"
      @click="handleEnemy(enemy.id, convert(enemy.lv))"
    />
  </div>
</template>

<script>
import EnemyFormationCard from "../components/EnemyFormationCard.vue";

export default {
  name: "EnemyWave",
  props: {
    wave: Object,
    origin: {
      type: String,
      default: "map",
    },
  },
  components: {
    EnemyFormationCard,
  },
  methods: {
    handleEnemy(id, lv) {
      this.$store.dispatch("setActiveEnemy", [id, lv]);
    },
    convert(lv) {
      if (isNaN(parseInt(lv))) {
        console.log(lv);
        return 0;
      } else return lv;
    },
  },
  computed: {
    normal() {
      return this.origin == "map";
    },
    sanctum() {
      return this.origin == "sanctum";
    },
    sanctumWave() {
      if (this.origin == "sanctum") {
        let w = [];
        for (let e in this.wave.e) {
          if (this.wave.e[e] == null) {
            w.push({ id: "", lv: 0 });
          } else w.push(this.wave.e[e]);
        }
        return w;
      } else return false;
    },
  },
};
</script>

<style>
.grid {
  display: inline-grid;
  gap: 0.75em;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  max-width: 100%;
}
</style>
